import axios from 'axios';

import { baseAPI } from '~shared/api/base-api';

async function parseBlobError(error: unknown): Promise<string> {
  if (!axios.isAxiosError(error) || !(error.response?.data instanceof Blob)) {
    return error instanceof Error ? error.message : 'Failed to download report';
  }

  try {
    const errorText = await error.response.data.text();
    if (!errorText) {
      return `Request failed with status ${error.response.status}`;
    }

    try {
      const errorJson = JSON.parse(errorText) as {
        message?: string | Array<string>;
        error?: string;
      };
      if (Array.isArray(errorJson.message)) {
        return errorJson.message.join(', ');
      }
      return (
        errorJson.message ??
        errorJson.error ??
        `Request failed with status ${error.response.status}`
      );
    } catch {
      return errorText;
    }
  } catch {
    return `Request failed with status ${error.response.status}`;
  }
}

export const consolidatedStudioDatabaseReportAPI = async (): Promise<Blob> => {
  try {
    const response = await baseAPI.get(
      'reporting/consolidated-studio-database',
      {
        responseType: 'blob',
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(await parseBlobError(error));
  }
};

export const downloadConsolidatedStudioDatabaseReport = async (): Promise<void> => {
  const blob = await consolidatedStudioDatabaseReportAPI();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'consolidated-studio-database-report.csv';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => {
    window.URL.revokeObjectURL(url);
  }, 100);
};
